
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed",
      function () {
        return require("private-next-pages/embed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed"])
      });
    }
  